export default __webpack_public_path__ + "static/media/image3.41c1e360.jpg";